import type { Me } from '$lib/types';

// Bootstrapped once after login; holds the current user and their
// accessible projects (already scoped by the backend — admins get all,
// members get their grants). The sidebar nav lists these directly; there's
// no separate "project switcher" concept in this shell.
class SessionState {
  me = $state<Me | null>(null);

  readonly isAdmin = $derived(this.me?.user.role === 'admin');

  setMe(me: Me) {
    this.me = me;
  }

  clear() {
    this.me = null;
  }
}

export const session = new SessionState();
